import React from 'react';
import { NuqsAdapter } from 'nuqs/adapters/next/pages';

const NuqsProvider: React.FC = ({ children }) => (
  <NuqsAdapter>
    {children}
  </NuqsAdapter>
);

export default NuqsProvider;